import { GET_BRICS_WORKGROUPS } from '../contants';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  data: [],
};

export default function bricsWorkgroups(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_BRICS_WORKGROUPS}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
        data: {},
      };
    case `${GET_BRICS_WORKGROUPS}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        data: action.result,
      };
    case `${GET_BRICS_WORKGROUPS}_FAIL`:
      return {
        ...state,
        error: action.result,
        loaded: false,
        loading: false,
        data: {},
      };
    default:
      return state;
  }
}
